import { render, staticRenderFns } from "./DetailArmod.vue?vue&type=template&id=3f54b955&scoped=true&"
import script from "./DetailArmod.vue?vue&type=script&lang=js&"
export * from "./DetailArmod.vue?vue&type=script&lang=js&"
import style0 from "./DetailArmod.vue?vue&type=style&index=0&id=3f54b955&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54b955",
  null
  
)

export default component.exports